import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild,
  inject,
} from '@angular/core';
import { IconNames } from '@app/shared/enums/icon-names';
import { InputWidth } from '@app/shared/models/input-width.model';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { IceIconButtonComponent } from '../../atoms/ice-icon-button/ice-icon-button.component';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

/**
 * Usage example:
 *
 * @example
 * <app-ice-search-field placeholder="Søk etter kunde" (searchTriggered)="onSearch($event)" [value]="searchText" />
 */

@Component({
  selector: 'app-ice-search-field',
  templateUrl: './ice-search-field.component.html',
  styleUrl: './ice-search-field.component.scss',
  imports: [MatIcon, FormsModule, IceIconButtonComponent],
})
export class IceSearchFieldComponent implements OnInit, AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) placeholder: string;
  @Input() value = '';
  @Input() inputWidth: InputWidth = '';
  @Input() autoTriggerSearch = true;

  @Output() searchTriggered = new EventEmitter<string>();

  valueSubject = new Subject<string>();

  @HostBinding('class') get class() {
    return this.inputWidth;
  }
  @HostListener('click') onClick() {
    this.searchInput?.nativeElement.focus();
  }

  @ViewChild('searchInput') searchInput: ElementRef;

  IconNames = IconNames;

  shouldShowClearIcon = signal(false);

  ngOnInit(): void {
    if (!!this.value) {
      this.cdr.markForCheck();
    }
  }

  ngAfterViewInit() {
    // Trigger the search event with debounce, only if autoTriggerSearch is true
    if (this.autoTriggerSearch) {
      this.valueSubject.pipe(debounceTime(500), distinctUntilChanged()).subscribe((search: string) => {
        this.searchTriggered.emit(search);
      });
    }
  }

  clearSearch(): void {
    this.value = '';
    this.searchTriggered.emit(this.value);
  }

  onEnter() {
    this.searchTriggered.emit(this.value);
    if (!this.autoTriggerSearch) {
      this.searchInput?.nativeElement.blur();
    }
  }
}
